/**
 * 시스템 > 모니터링 설정 > 이벤트 공통 설정 Store
 *
 * @since 2018-03-19
 * @author devp021
 */

import {getCodeJsonRow} from '~/utils/device-common'

export const state = () => ({
  apiUrl: {
    event: '/api/sm/event', // 이벤트 등급 설정 조회/적용 API
    eventLevel: '/api/sm/event-level', // 이벤트 등급 설정 조회/적용 (색상/소리) API
    eventSound: '/api/sm/event-sound', // 사운드 파일 가져오기 API
    eventInit: 'api/sm/event/init' // 이벤트 초기화 API
  },
  eventLevelList: [],
  eventList: [],
  eventLevelTypeGroup: [],
  eventCodeGroup: [],
  eventSoundList: [],
  initMsg: '',
  applyMsg: ''
})

export const mutations = {
  setEventLevelTypeGroup (state) {
    const eventLevelType = getCodeJsonRow('event_level_type')
    state.eventLevelTypeGroup = []
    for (let i = 0; i < eventLevelType.length; i++) {
      state.eventLevelTypeGroup.push({label: eventLevelType[i].val, value: eventLevelType[i].key})
    }
  },
  setEventLevelTypeName (state, key) {
    return state.eventLevelTypeGroup[--key].label
  },
  // '등급별 색상 및 소리 설정' 설정
  setEventLevelList (state, res) {
    mutations.setEventLevelTypeGroup(state)
    state.eventLevelList = res

    const temp = []
    for (let i = 0; i < state.eventLevelList.length; i++) {
      temp.push({
        event_level_color: state.eventLevelList[i].event_level_color,
        event_level_type: state.eventLevelList[i].event_level_type,
        event_level_type_name: mutations.setEventLevelTypeName(state, state.eventLevelList[i].event_level_type),
        event_sound_file_name: state.eventLevelList[i].event_sound_file_name,
        event_sound_id: state.eventLevelList[i].event_sound_id,
        event_sound_name: state.eventLevelList[i].event_sound_name,
        event_sound_pre_def_yn: state.eventLevelList[i].event_sound_pre_def_yn
      })
    }

    state.eventLevelList = temp
  },
  setEventCodeGroup (state) {
    state.eventCodeGroup = []
    state.eventCodeGroup = getCodeJsonRow('event_code')
  },
  setEventCodeName (state, key) {
    for (let i = 0; i < state.eventCodeGroup.length; i++) { // forEach로 하면 마지막 항목까지 루프 (break 불가)
      if (key === state.eventCodeGroup[i].key) {
        return state.eventCodeGroup[i].val
      }
    }
  },
  // '이벤트별 등급 설정' 설정
  setEventList (state, res) {
    mutations.setEventCodeGroup(state)
    state.eventList = res

    const temp = []
    for (let i = 0; i < state.eventList.length; i++) {
      temp.push({
        event_code: state.eventList[i].event_code,
        event_code_name: mutations.setEventCodeName(state, state.eventList[i].event_code),
        event_level_type: state.eventList[i].event_level_type,
        event_level_color: state.eventList[i].event_level_color
      })
    }

    state.eventList = temp
  },
  // 이벤트 사운드 목록 설정
  setEventSoundList (state, res) {
    state.eventSoundList = res
  },
  setInitMsg (state, msg) {
    state.initMsg = msg
  },
  setApplyMsg (state, msg) {
    state.applyMsg = msg
  }
}

export const actions = {
  // 현재 범위 참조 : dispatch
  // mutation 범위 참조 : commit
  // 등급별 색상 및 소리 설정 조회
  async getEventLevelListAxios ({commit, state}) {
    try {
      const data = await this.$axios.$get(state.apiUrl.eventLevel, {loading: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('setEventLevelList', data.result)
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // 이벤트별 등급 설정 조회
  async getEventListAxios ({commit, state, rootState}) {
    try {
      const data = await this.$axios.$get(state.apiUrl.event, {loading: false})
      const ccFlag = rootState.common.common.uiData.system.cc_flag
      let ccResult = []
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      if (ccFlag) {
        ccResult = data.result.filter(obj => obj.event_code !== 277010600 && obj.event_code !== 277010800)
      }
      const result = ccFlag ? ccResult : data.result
      commit('setEventList', result)
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // 이벤트 공통 설정 초기화
  async initCommonCommandAxios ({state, dispatch}) {
    const res = {code: 'ok'}
    try {
      const {code} = await this.$axios.$delete(state.apiUrl.eventInit, {alertMsg: state.initMsg})
      if (code.toLowerCase() === 'ok') {
        dispatch('getEventLevelListAxios')
        dispatch('getEventListAxios')
        res.reason = 'SUCCESS'
      } else {
        res.reason = 'FAIL'
      }
      return res
    } catch (e) {
      res.code = 'nok'
      res.reason = e.message
      return res
    }
  },
  // 등급별 색상 및 소리 설정 적용
  async applyEventLevelListAxios ({state}) {
    const eventLevelList = []

    for (let i = 0; i < state.eventLevelList.length; i++) {
      eventLevelList.push({
        event_level_color: state.eventLevelList[i].event_level_color,
        event_level_type: state.eventLevelList[i].event_level_type,
        event_sound_id: (state.eventLevelList[i].event_sound_id === null) ? 'null' : state.eventLevelList[i].event_sound_id
      })
    }

    try {
      const res = await this.$axios.$put(state.apiUrl.eventLevel, {list: eventLevelList}, {loading: false, applyMsg: false, alertMsg: ''})
      if (res.code.toUpperCase() !== 'OK') {
        return {code: 'nok', errors: res.result.msg}
      }
      // dispatch('getEventLevelListAxios')
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // 이벤트별 등급 설정 적용
  async applyEventListAxios ({state}) {
    let eventLevelTypeFan = ''
    let eventLevelTypePsu = ''

    for (let i = 0; i < state.eventList.length; i++) {
      if (state.eventList[i].event_code === 277014010) {
        eventLevelTypeFan = state.eventList[i].event_level_type
      } else if (state.eventList[i].event_code === 277015010) {
        eventLevelTypePsu = state.eventList[i].event_level_type
      }
    }

    for (let i = 0; i < state.eventList.length; i++) {
      if ([277014020, 277014030, 277014040, 277014050, 277014060, 277014070, 277014080].includes(state.eventList[i].event_code)) {
        state.eventList[i].event_level_type = eventLevelTypeFan
      } else if (state.eventList[i].event_code === 277015020) {
        state.eventList[i].event_level_type = eventLevelTypePsu
      }
    }

    try {
      const res = await this.$axios.$put(state.apiUrl.event, {list: state.eventList}, {applyMsg: false, alertMsg: state.applyMsg})
      if (res.code.toUpperCase() !== 'OK') {
        return {code: 'nok', errors: res.result.msg}
      }
      // dispatch('getEventListAxios')
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // 이벤트 소리 목록 조회
  async getEventSoundListAxios ({commit, state}) {
    try {
      const data = await this.$axios.$get(state.apiUrl.eventSound, {loading: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('setEventSoundList', data.result)
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // 이벤트 소리 삭제
  async delEventSoundAxios ({state, dispatch}) {
    const res = {code: 'ok'}
    try {
      const {code} = await this.$axios.$delete(state.apiUrl.eventSound + '/' + state.eventSoundList.event_sound_id) // multi 삭제가능하게할지 확인.
      if (code.toLowerCase() === 'ok') {
        // dispatch('getEventLevelListAxios')
        dispatch('getEventSoundListAxios')
        res.reason = 'SUCCESS'
      } else {
        res.reason = 'FAIL'
      }
      return res
    } catch (e) {
      res.code = 'nok'
      res.reason = e.message
      return res
    }
  },
  async commitAndRollBackPage ({commit, state}, type) {
    try {
      let msg = {}
      if (type === 'apply') {
        msg = {loading: false, applyMsg: false, successAlert: false}
      } else if (type === 'cancel') {
        msg = {loading: false, cancelMsg: false, successAlert: false}
      }
      const data = await this.$axios.$put(`${state.apiUrl.event}/${type}`, null, msg)
      if (data.code !== 'ok') {
        return false
      }
      this.dispatch(`common/common/setIsChanged`, false)
      return 'ok'
    } catch (error) {
      return error
    }
  }
}

export const getters = {}

export const strict = false
